module.exports = __webpack_public_path__ + "static/media/ZT7.2d5e0caf.jpg";